/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { TollPool } from "./TollPool";

export class TollPoolFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<TollPool> {
    return super.deploy(overrides || {}) as Promise<TollPool>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TollPool {
    return super.attach(address) as TollPool;
  }
  connect(signer: Signer): TollPoolFactory {
    return super.connect(signer) as TollPoolFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TollPool {
    return new Contract(address, _abi, signerOrProvider) as TollPool;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "FeeTokenAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "feeTokenPoolDispatcher",
        type: "address",
      },
    ],
    name: "FeeTokenPoolDispatcherSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "FeeTokenRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokenReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokenTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "TOKEN_AMOUNT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
    ],
    name: "addFeeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "clearingHouse",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "clientBridge",
    outputs: [
      {
        internalType: "contract ClientBridge",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeTokenPoolDispatcherL1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "feeTokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFeeTokenLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_clearingHouse",
        type: "address",
      },
      {
        internalType: "contract ClientBridge",
        name: "_clientBridge",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
    ],
    name: "isFeeTokenExisted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
    ],
    name: "removeFeeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeTokenPoolDispatcherL1",
        type: "address",
      },
    ],
    name: "setFeeTokenPoolDispatcher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transferToFeeTokenPoolDispatcher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
